import React, { useState, useEffect } from 'react';
import { Card, Button, Modal, Form } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import Cookies from 'js-cookie';
import { Fetcher } from '../../Helpers/fetcher';
import { Notify } from '../../Helpers/notification';
import {useHistory} from 'react-router-dom'

const FlashMessages = ({ app }) => {
    const history =useHistory()
    const [messages, setMessages] = useState([]);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [modal, setModal] = useState({ show: false, data: null, editable: false });
    const fetchMessages = () => {
        Fetcher.get(`${app.apiPath}/api/obd/get/flash/messages`)
            .then(res => {
                setMessages(res);
            })
            .catch(err => {
                console.error('Error fetching flash messages:', err);
                Notify.notify('Failed to fetch flash messages');
            });
    };

    useEffect(() => {
        if (app.role !== 'ROLE_SADMIN') {
            history.replace('/');
        }
    }, [app.role, history]);

    useEffect(() => {
        const savedSize = Cookies.get('flashMessagesSizePerPage');
        if (savedSize) setSizePerPage(Number(savedSize));
        fetchMessages();
        
    }, []);

    const handleSizePerPageChange = (newSize) => {
        setSizePerPage(newSize);
        Cookies.set('flashMessagesSizePerPage', newSize);
    };

    const handleSave = () => {
        if (!modal.data) return;

        const payload = {
            id: modal.data.id,
            message: modal.data.message,
            action: modal.data.action
        };

        Fetcher.post(`${app.apiPath}/api/obd/edit/flash/message`, {
            method: "POST", headers: {
                "Content-Type": "application/json"
            }, body: JSON.stringify(payload)
        })
            .then(res => {
                Notify.notify('Message updated successfully');
                setModal({ show: false, data: null, editable: false });
                fetchMessages();
            })
            .catch(err => {
                console.error('Error updating message:', err);
                Notify.notify('Failed to update message');
            });
    };

    const columns = [
        { dataField: 'id', text: 'ID', sort: true },
        { dataField: 'moduleName', text: 'Module' },
        { dataField: 'action', text: 'Action' },
        {
            dataField: 'message',
            text: 'Message',
            formatter: (_, row) =>
                _ ? (
                    <Button
                        size="sm"
                        onClick={() => setModal({ show: true, data: row, editable: false })}
                    >
                        View
                    </Button>
                ) : ''

        }
    ];

    const { SearchBar, ClearSearchButton } = Search;
    const paginationOptions = {
        custom: true,
        totalSize: messages.length,
        sizePerPage,
        sizePerPageList: [10, 25, 50, 100],
        onSizePerPageChange: handleSizePerPageChange
    };

    return (
        <Card>
            <Card.Header>Flash Messages</Card.Header>
            <Card.Body>
                <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                    {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider keyField="id" data={messages} columns={columns} search bootstrap4>
                            {props => (
                                <>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            Show <SizePerPageDropdownStandalone {...paginationProps} />
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <SearchBar {...props.searchProps} />
                                            <ClearSearchButton className="btn btn-primary mb-2" {...props.searchProps} />
                                        </div>
                                    </div>

                                    <BootstrapTable
                                        bordered
                                        hover
                                        condensed
                                        wrapperClasses="table-responsive"
                                        classes="flash-messages-table"
                                        {...props.baseProps}
                                        {...paginationTableProps}
                                        noDataIndication="No messages found"
                                    />

                                    <PaginationListStandalone {...paginationProps} />
                                </>
                            )}
                        </ToolkitProvider>
                    )}
                </PaginationProvider>

                {/* Modal */}
                <Modal
                    show={modal.show}
                    onHide={() => setModal({ show: false, data: null, editable: false })}
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Message Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex align-items-start gap-2">
                            <Form.Control
                                as="textarea"
                                rows={4}
                                value={modal.data?.message || ''}
                                readOnly={!modal.editable}
                                onChange={e =>
                                    setModal({ ...modal, data: { ...modal.data, message: e.target.value } })
                                }
                            />
                            {!modal.editable && (
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => setModal({ ...modal, editable: true })}
                                >
                                    <i className="fa fa-pencil"></i>
                                </Button>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setModal({ show: false, data: null, editable: false })}
                        >
                            Close
                        </Button>
                        {modal.editable && (
                            <Button variant="primary" onClick={handleSave}>
                                Save
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            </Card.Body>
        </Card>
    );
};

export default FlashMessages;
